import { useEffect, useState } from "react";
import { DateTime } from "luxon";

const MIN_DELAY_MS = 1_000;
const BOUNDARY_SLACK_MS = 250;
const NO_BOUNDARIES: number[] = [];

export const nextDelay = (
  boundaries: number[],
  nowMillis: number,
  maxDelayMs: number
) => {
  const upcoming = boundaries.filter((millis) => millis > nowMillis);
  const untilBoundary = upcoming.length
    ? Math.min(...upcoming) - nowMillis + BOUNDARY_SLACK_MS
    : maxDelayMs;
  return Math.min(Math.max(untilBoundary, MIN_DELAY_MS), maxDelayMs);
};

export const useNow = ({
  boundaries = NO_BOUNDARIES,
  maxDelayMs = 60_000
}: {
  boundaries?: number[];
  maxDelayMs?: number;
} = {}) => {
  const [now, setNow] = useState(() => DateTime.now());

  useEffect(() => {
    const timer = setTimeout(
      () => setNow(DateTime.now()),
      nextDelay(boundaries, Date.now(), maxDelayMs)
    );
    return () => clearTimeout(timer);
  }, [now, boundaries, maxDelayMs]);

  return now;
};
